// Seed data for PawCita MVP. Bruce uses the real photo at /Bruce.JPG.
export const BRUCE_ID = "bruce-001";

export const bruceSeed = {
  id: BRUCE_ID,
  name: "Bruce",
  breed: "Jack Russell Terrier",
  age: 3,
  sex: "Macho",
  size: "Pequeño",
  weight: "8 kg",
  color: "Blanco con marrón",
  health: "Sin enfermedades",
  illnessDetail: "",
  vaccines: true,
  dewormed: true,
  lastVetCheck: "2026-01-12",
  pedigree: "No sé",
  sterilized: false,
  temperament: ["Sociable", "Juguetón", "Noble"],
  compatibility: "Se lleva bien con otros perros",
  location: "Panamá, C. de P.",
  available: true,
  heatCycle: "",
  notes:
    "Bruce es un Jack Russell muy activo, cariñoso y socializa bien con otros perros.",
  image: "/Bruce.JPG",
  owner: "Familia de Bruce",
  verified: true,
  distance: "0 km",
};

export const dogsSeed = [
  {
    id: "dog-luna",
    name: "Luna",
    breed: "Golden Retriever",
    age: 3,
    sex: "Hembra",
    size: "Grande",
    weight: "28 kg",
    color: "Dorado",
    distance: "4 km",
    location: "Panamá, C. de P.",
    health: "Sin enfermedades",
    illnessDetail: "",
    vaccines: true,
    dewormed: true,
    lastVetCheck: "2026-01-05",
    pedigree: "Sí",
    sterilized: false,
    temperament: ["Sociable", "Cariñosa", "Juguetona"],
    compatibility: "Excelente con otros perros",
    available: true,
    heatCycle: "Cada 6 meses",
    owner: "María González",
    verified: true,
    image:
      "https://images.unsplash.com/photo-1552053831-71594a27632d?q=80&w=900&auto=format&fit=crop",
    notes:
      "Luna es muy sociable, le encanta el parque y convive bien con otros perros.",
  },
  {
    id: "dog-max",
    name: "Max",
    breed: "Poodle",
    age: 2,
    sex: "Macho",
    size: "Pequeño",
    weight: "7 kg",
    color: "Apricot",
    distance: "7 km",
    location: "San Francisco, Panamá",
    health: "Sin enfermedades",
    illnessDetail: "",
    vaccines: true,
    dewormed: true,
    lastVetCheck: "2025-12-18",
    pedigree: "Sí",
    sterilized: false,
    temperament: ["Juguetón", "Activo", "Dócil"],
    compatibility: "Buena socialización",
    available: true,
    owner: "Carlos Pérez",
    verified: true,
    image:
      "https://images.unsplash.com/photo-1605568427561-40dd23c2acea?q=80&w=900&auto=format&fit=crop",
    notes: "Max es alegre, pequeño y muy acostumbrado a socializar.",
  },
  {
    id: "dog-rocky",
    name: "Rocky",
    breed: "Bulldog Francés",
    age: 4,
    sex: "Macho",
    size: "Mediano",
    weight: "12 kg",
    color: "Atigrado",
    distance: "3 km",
    location: "Costa del Este, Panamá",
    health: "Alergia leve controlada",
    illnessDetail: "Alergia cutánea leve controlada con dieta.",
    vaccines: true,
    dewormed: true,
    lastVetCheck: "2025-11-30",
    pedigree: "No",
    sterilized: false,
    temperament: ["Tranquilo", "Protector", "Cariñoso"],
    compatibility: "Prefiere perros de energía media o baja",
    available: true,
    owner: "Andrea Rodríguez",
    verified: false,
    image:
      "https://images.unsplash.com/photo-1583512603806-077998240c7a?q=80&w=900&auto=format&fit=crop",
    notes: "Rocky es tranquilo, ideal para perros con energía media o baja.",
  },
  {
    id: "dog-nala",
    name: "Nala",
    breed: "Husky Siberiano",
    age: 2,
    sex: "Hembra",
    size: "Grande",
    weight: "21 kg",
    color: "Blanco y gris",
    distance: "9 km",
    location: "Clayton, Panamá",
    health: "Sin enfermedades",
    illnessDetail: "",
    vaccines: true,
    dewormed: false,
    lastVetCheck: "2025-10-22",
    pedigree: "No",
    sterilized: false,
    temperament: ["Activa", "Curiosa", "Sociable"],
    compatibility: "Bien con perros enérgicos",
    available: true,
    heatCycle: "Cada 7 meses",
    owner: "Valeria Méndez",
    verified: true,
    image:
      "https://images.unsplash.com/photo-1605897472359-85e4b94d685d?q=80&w=900&auto=format&fit=crop",
    notes:
      "Nala ama correr y necesita espacios abiertos para conocerse con calma.",
  },
];

export const seedReceivedRequests = [
  {
    id: "req-in-1",
    dog: dogsSeed[1], // Max
    status: "Recibida",
    message:
      "Hola, Max quiere conocer a Bruce. ¿Les gustaría coordinar?",
    createdAt: "Hace 2 h",
  },
  {
    id: "req-in-2",
    dog: dogsSeed[3], // Nala
    status: "Recibida",
    message:
      "Hola, Nala es muy sociable. ¿Les gustaría planear un paseo juntos para ver si hay química?",
    createdAt: "Ayer",
  },
];

export const seedChats = {
  // key = dog id, messages seeded
  "dog-luna": {
    dog: dogsSeed[0],
    ownerName: "María",
    messages: [
      {
        id: "m1",
        from: "María",
        text: "Hola, vi el perfil de Bruce. ¡Me encantó! 😍",
        mine: false,
        time: "9:15 a.m.",
      },
      {
        id: "m2",
        from: "Yo",
        text: "Hola María, gracias. A nosotros también nos encantó Luna 🐶",
        mine: true,
        time: "9:17 a.m.",
      },
      {
        id: "m3",
        from: "María",
        text: "¿Les parece si nos vemos el sábado en un parque para que se conozcan con calma?",
        mine: false,
        time: "9:19 a.m.",
      },
    ],
    appointment: {
      place: "Parque Omar",
      day: "Sábado",
      date: "2026-02-14",
      hour: "10:00 a.m.",
      notes: "Llevaremos correa larga y agua fresca.",
      status: "Pendiente",
    },
  },
};

export const userProfile = {
  name: "Tú",
  city: "Panamá, C. de P.",
  verified: true,
};
